/* GEHNA: shared helper - open the cart drawer after an add-to-cart done by our own buttons.
   When the cart was empty the theme leaves an "is-empty" class on <cart-drawer>, which hides the items and header.
   We remove it before the theme draws the new content. Returns false if there is no cart drawer on the page. */
window.gxOpenCartDrawer = function (data) {
  var d = document.querySelector('cart-drawer');
  if (!d || typeof d.renderContents !== 'function') return false;
  try {
    d.classList.remove('is-empty');
    d.renderContents(data);
    return true;
  } catch (e) {
    return false;
  }
};

/* GEHNA: product gallery arrows (beside the thumbnails) move to the previous / next image.
   The theme DISABLES these arrows when all thumbnails already fit on screen, and a disabled button ignores clicks.
   So we keep them enabled and make them switch the big image. */
(function () {
  function unlock() {
    document.querySelectorAll('.thumbnail-slider .slider-button').forEach(function (b) {
      if (b.hasAttribute('disabled')) b.removeAttribute('disabled');
    });
  }

  function watch() {
    document.querySelectorAll('.thumbnail-slider').forEach(function (s) {
      if (s.dataset.gxWatch) return;
      s.dataset.gxWatch = '1';
      if (window.MutationObserver) {
        new MutationObserver(unlock).observe(s, { attributes: true, subtree: true, attributeFilter: ['disabled'] });
      }
    });
    unlock();
  }

  document.addEventListener('DOMContentLoaded', watch);
  window.addEventListener('load', watch);
  document.addEventListener('shopify:section:load', watch);
  watch();
  setTimeout(watch, 400);
  setTimeout(watch, 1500);

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('.thumbnail-slider .slider-button') : null;
    if (!btn) return;
    var slider = btn.closest('.thumbnail-slider');
    if (!slider) return;

    var items = Array.prototype.slice.call(slider.querySelectorAll('.thumbnail-list__item')).filter(function (li) {
      return li.offsetParent !== null;
    });
    if (items.length < 2) return;

    var cur = 0;
    items.forEach(function (li, i) {
      var b = li.querySelector('button.thumbnail');
      if (b && b.getAttribute('aria-current') === 'true') cur = i;
    });
    var dir = btn.name === 'next' ? 1 : -1;
    var idx = (cur + dir + items.length) % items.length;

    /* replace the theme's own (scroll-only) behaviour */
    e.preventDefault();
    e.stopImmediatePropagation();

    var target = items[idx];
    var tb = target.querySelector('button.thumbnail');
    if (tb) tb.click();
    var list = target.parentNode;
    try {
      list.scrollTo({ left: target.offsetLeft - (list.clientWidth - target.clientWidth) / 2, behavior: 'smooth' });
    } catch (err) {}
  }, true);
})();

/* GEHNA: "Key Features" card on the product image. It is CLOSED by default (desktop and mobile); the small arrow tab opens it.
   The features are read from the product DESCRIPTION: every line written like "Material: Glass with gold-tone finish"
   (bullet points, paragraphs or lines split by a line break) becomes one feature. So whatever is written in the
   description shows up here automatically. If the description has no such lines, it falls back to the
   Jewellery / Product details rows (product metafields). If there is nothing at all, the card is not shown. */
(function () {
  var MAX = 4;
  var CSS = ''
    + '.gx-kf-host{position:relative}'
    + '.gx-kf{position:absolute;left:0;top:50%;transform:translateY(-50%);z-index:4;display:flex;align-items:center;max-width:78%}'
    + '.gx-kf__panel{width:19rem;max-width:100%;box-sizing:border-box;margin-left:1.2rem;padding:1.4rem 1.6rem;background:rgba(255,255,255,0.94);-webkit-backdrop-filter:blur(6px);backdrop-filter:blur(6px);border-radius:1.6rem;box-shadow:0 6px 24px rgba(36,31,28,0.15);text-align:left}'
    + '.gx-kf:not(.gx-kf--open) .gx-kf__panel{display:none}'
    + '.gx-kf__title{margin:0 0 1rem;font-size:1.5rem;font-weight:700;line-height:1.2;color:#7A3E4D}'
    + '.gx-kf__row{padding:0 0 0.8rem;margin:0 0 0.8rem;border-bottom:1px dashed #E3C5CC}'
    + '.gx-kf__row:last-child{padding-bottom:0;margin-bottom:0;border-bottom:0}'
    + '.gx-kf__label{margin:0;font-size:1.1rem;line-height:1.3;color:#7A3E4D}'
    + '.gx-kf__value{margin:0.2rem 0 0;font-size:1.3rem;font-weight:700;line-height:1.3;color:#241F1C;word-break:break-word}'
    + '.gx-kf__tab{flex:none;width:2.4rem;height:5.6rem;margin-left:-0.2rem;padding:0;display:flex;align-items:center;justify-content:center;background:rgba(255,255,255,0.96);border:0;border-radius:0 1rem 1rem 0;box-shadow:0 4px 14px rgba(36,31,28,0.15);color:#7A3E4D;cursor:pointer;-webkit-tap-highlight-color:transparent}'
    + '.gx-kf:not(.gx-kf--open) .gx-kf__tab{margin-left:0}'
    + '.gx-kf__tab svg{transition:transform 0.2s ease}'
    + '.gx-kf:not(.gx-kf--open) .gx-kf__tab svg{transform:rotate(180deg)}'
    + '@media screen and (max-width:749px){.gx-kf__panel{width:15.5rem;margin-left:0.8rem;padding:1.1rem 1.2rem}.gx-kf__title{font-size:1.3rem;margin-bottom:0.8rem}.gx-kf__value{font-size:1.2rem}}';
  var CHEV = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 6l-6 6 6 6"/></svg>';

  function clean(v) {
    return String(v || '').replace(/\s+/g, ' ').trim();
  }

  function short(v) {
    v = clean(v);
    if (v.charAt(v.length - 1) === '.') v = v.slice(0, -1);
    return v.length > 42 ? v.slice(0, 40) + '...' : v;
  }

  function collect() {
    var out = [];
    var seen = {};
    function add(l, v) {
      l = clean(l);
      v = short(v);
      var k = l.toLowerCase();
      if (!l || !v || v.length < 2 || seen[k]) return;
      seen[k] = 1;
      out.push([l, v]);
    }

    /* 1) the product description: lines like "Label: value" */
    document.querySelectorAll('.product__description').forEach(function (root) {
      var nodes = root.querySelectorAll('li, p');
      var list = nodes.length ? Array.prototype.slice.call(nodes) : [root];
      list.forEach(function (node) {
        var copy = node.cloneNode(true);
        copy.querySelectorAll('br').forEach(function (b) {
          b.parentNode.replaceChild(document.createTextNode('\n'), b);
        });
        String(copy.textContent || '').split('\n').forEach(function (line) {
          line = clean(line);
          var i = line.indexOf(':');
          if (i < 2 || i > 28 || line.length < i + 3) return;
          var label = line.slice(0, i);
          if (label.split(' ').length > 4) return;
          if (label.indexOf('http') > -1) return;
          add(label, line.slice(i + 1));
        });
      });
    });

    /* 2) fallback: the product detail rows (they read the product metafields) */
    if (!out.length) {
      document.querySelectorAll('.product-details__row').forEach(function (r) {
        var dt = r.querySelector('dt');
        var dd = r.querySelector('dd');
        if (dt && dd) add(dt.textContent, dd.textContent);
      });
    }
    return out.slice(0, MAX);
  }

  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }

  function build() {
    var viewer = document.querySelector('media-gallery [id^="GalleryViewer"]');
    if (!viewer || viewer.querySelector('.gx-kf')) return;
    var rows = collect();
    if (!rows.length) return;

    if (!document.getElementById('gx-kf-css')) {
      var st = document.createElement('style');
      st.id = 'gx-kf-css';
      st.textContent = CSS;
      document.head.appendChild(st);
    }
    viewer.classList.add('gx-kf-host');

    /* closed by default on every screen size */
    var box = el('div', 'gx-kf');

    var panel = el('div', 'gx-kf__panel');
    panel.appendChild(el('h3', 'gx-kf__title', 'Key Features'));
    rows.forEach(function (r) {
      var row = el('div', 'gx-kf__row');
      row.appendChild(el('p', 'gx-kf__label', r[0]));
      row.appendChild(el('p', 'gx-kf__value', r[1]));
      panel.appendChild(row);
    });
    box.appendChild(panel);

    var tab = el('button', 'gx-kf__tab');
    tab.type = 'button';
    tab.innerHTML = CHEV;
    tab.setAttribute('aria-expanded', 'false');
    tab.setAttribute('aria-label', 'Show or hide key features');
    tab.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var nowOpen = box.classList.toggle('gx-kf--open');
      tab.setAttribute('aria-expanded', nowOpen ? 'true' : 'false');
    });
    box.appendChild(tab);

    /* keep taps on the card from opening the image zoom */
    box.addEventListener('click', function (e) { e.stopPropagation(); });

    viewer.appendChild(box);
  }

  document.addEventListener('DOMContentLoaded', build);
  document.addEventListener('shopify:section:load', build);
  window.addEventListener('load', build);
  build();
  setTimeout(build, 600);
})();

/* GEHNA: "See Similar" button on the product image. Opens a popup with products that are really similar:
   same kind of product (rings -> rings, bracelets -> bracelets, perfumes -> perfumes ...), ranked by product type,
   tags, title words, vendor and price. Falls back to Shopify's own recommendations if nothing matches.
   SPEED: nothing is downloaded while the page loads. The product list is fetched only when the customer
   hovers / touches / clicks the button. */
(function () {
  var parts = location.pathname.split('/products/');
  if (parts.length < 2) return;
  var HANDLE = '';
  try { HANDLE = decodeURIComponent(parts[1].split('/')[0]); } catch (e) { HANDLE = parts[1].split('/')[0]; }
  if (!HANDLE) return;

  var LIMIT = 8;

  /* kind of product, detected from words in the title / product type / tags. Add more words here if needed. */
  var CATS = {
    ring: ['ring', 'rings'],
    bangle: ['bangle', 'bangles', 'kada', 'kadas'],
    bracelet: ['bracelet', 'bracelets'],
    necklace: ['necklace', 'necklaces', 'pendant', 'pendants', 'chain', 'chains', 'choker', 'mangalsutra', 'haar', 'locket'],
    earring: ['earring', 'earrings', 'stud', 'studs', 'jhumka', 'jhumkas', 'jhumki', 'chandbali', 'hoop', 'hoops'],
    anklet: ['anklet', 'anklets', 'payal'],
    watch: ['watch', 'watches'],
    nosepin: ['nosepin', 'nosering', 'nath'],
    fragrance: ['perfume', 'perfumes', 'parfum', 'parfums', 'deo', 'deodorant', 'attar', 'fragrance', 'cologne', 'mist', 'spray', 'bodyspray'],
    makeup: ['lipstick', 'lip', 'lipgloss', 'kajal', 'eyeliner', 'mascara', 'foundation', 'compact', 'blush', 'eyeshadow', 'concealer', 'primer'],
    skincare: ['cream', 'serum', 'moisturizer', 'moisturiser', 'sunscreen', 'facewash', 'cleanser', 'toner', 'lotion', 'mask'],
    haircare: ['shampoo', 'conditioner']
  };
  var TOKEN_CAT = {};
  Object.keys(CATS).forEach(function (c) {
    CATS[c].forEach(function (w) { TOKEN_CAT[w] = c; });
  });
  var STOP = { 'for': 1, 'with': 1, 'and': 1, 'the': 1, 'women': 1, 'woman': 1, 'men': 1, 'girls': 1, 'pack': 1, 'combo': 1, 'from': 1, 'your': 1, 'this': 1 };
  var GENERIC_TAGS = { 'new': 1, 'bestseller': 1, 'hot': 1, 'sale': 1, 'featured': 1, 'new arrival': 1, 'new arrivals': 1 };

  var CSS = ''
    + '.gx-sim-host{position:relative}'
    + '.gx-sim-btn{position:absolute;right:1.2rem;bottom:1.2rem;z-index:4;display:inline-flex;align-items:center;gap:0.6rem;padding:0.7rem 1.2rem;background:rgba(255,255,255,0.94);border:1px solid #E6DFD6;border-radius:999px;box-shadow:0 2px 8px rgba(36,31,28,0.12);font:inherit;font-size:1.2rem;font-weight:600;color:#241F1C;cursor:pointer;-webkit-tap-highlight-color:transparent}'
    + '.gx-sim-btn svg{flex:none;color:#7A3E4D}'
    + '.gx-sim-overlay{position:fixed;top:0;right:0;bottom:0;left:0;z-index:2000;display:flex;align-items:flex-end;justify-content:center;background:rgba(36,31,28,0.55)}'
    + '.gx-sim-panel{position:relative;width:100%;max-width:92rem;max-height:86vh;overflow:auto;box-sizing:border-box;padding:2rem 1.6rem 2.4rem;background:#fff;border-radius:1.6rem 1.6rem 0 0;text-align:left}'
    + '@media screen and (min-width:750px){.gx-sim-overlay{align-items:center}.gx-sim-panel{padding:2.4rem;border-radius:1.6rem}}'
    + '.gx-sim-head{display:flex;align-items:center;justify-content:space-between;margin-bottom:1.6rem}'
    + '.gx-sim-title{margin:0;font-size:2rem;line-height:1.2}'
    + '.gx-sim-close{flex:none;width:3.6rem;height:3.6rem;padding:0;border:0;border-radius:50%;background:#F3EFE9;font-size:2rem;line-height:1;color:#241F1C;cursor:pointer}'
    + '.gx-sim-grid{display:grid;grid-template-columns:repeat(2,1fr);gap:1.2rem}'
    + '@media screen and (min-width:750px){.gx-sim-grid{grid-template-columns:repeat(4,1fr);gap:1.6rem}}'
    + '.gx-sim-msg{padding:3rem 0;text-align:center;font-size:1.4rem;color:#625B56}'
    + '.gx-sim-card{min-width:0}'
    + '.gx-sim-media{display:block;aspect-ratio:1/1;overflow:hidden;border-radius:0.8rem;background:#F3EFE9}'
    + '.gx-sim-media img{display:block;width:100%;height:100%;object-fit:cover}'
    + '.gx-sim-price{margin:1rem 0 0.2rem;font-size:1.5rem;font-weight:600;color:#241F1C}'
    + '.gx-sim-price s{margin-left:0.6rem;font-weight:400;color:#625B56}'
    + '.gx-sim-name{display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;min-height:2.8em;margin:0 0 1rem;font-size:1.4rem;line-height:1.4;color:#241F1C;text-decoration:none}'
    + '.gx-sim-add{display:flex;align-items:center;justify-content:center;width:100%;box-sizing:border-box;min-height:4rem;padding:0 1rem;border:0;border-radius:0.8rem;background:#241F1C;color:#fff;font:inherit;font-size:1.3rem;font-weight:600;text-decoration:none;cursor:pointer}'
    + '.gx-sim-add[disabled]{opacity:0.6;cursor:not-allowed}';
  var ICON = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="5" width="11" height="14" rx="2"/><path d="M17 7.5l3 1v9l-3 1"/></svg>';

  var loaded = null;   /* promise of the similar products, fetched once */
  var overlay = null;
  var prevOverflow = '';

  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }

  /* prices may come as cents (number) or as a decimal string like "329.00" */
  function cents(v) {
    if (v == null || v === '') return 0;
    if (typeof v === 'string' && v.indexOf('.') > -1) return Math.round(parseFloat(v) * 100);
    return Number(v) || 0;
  }

  function money(c) {
    var code = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'INR';
    if (code === 'INR') return 'Rs. ' + (c / 100).toFixed(2);
    try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: code }).format(c / 100); }
    catch (e) { return (c / 100).toFixed(2); }
  }

  function sized(url) {
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=480';
  }

  /* ---------- similarity ---------- */
  function tokens(str) {
    return String(str || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').split(' ').filter(Boolean);
  }

  function normTags(t) {
    if (Array.isArray(t)) return t.map(function (x) { return String(x).trim(); }).filter(Boolean);
    return String(t || '').split(',').map(function (x) { return x.trim(); }).filter(Boolean);
  }

  function catsFrom(tokenList) {
    var out = {};
    tokenList.forEach(function (t) { if (TOKEN_CAT[t]) out[TOKEN_CAT[t]] = 1; });
    return out;
  }

  function priceOf(p) {
    var vs = p.variants || [];
    if (vs.length) {
      var arr = vs.map(function (v) { return cents(v.price); }).filter(function (n) { return n > 0; });
      if (arr.length) return Math.min.apply(null, arr);
    }
    return cents(p.price);
  }

  function info(p) {
    var type = String(p.product_type || p.type || '').trim().toLowerCase();
    var tags = normTags(p.tags).map(function (t) { return t.toLowerCase(); }).filter(function (t) {
      return !GENERIC_TAGS[t] && !/^[0-9]/.test(t);
    });
    var titleTokens = tokens(String(p.title || '') + ' ' + type);
    var words = {};
    titleTokens.forEach(function (t) { if (t.length > 3 && !STOP[t] && !TOKEN_CAT[t]) words[t] = 1; });
    var tagSet = {};
    tags.forEach(function (t) { tagSet[t] = 1; });
    return {
      type: type,
      titleCats: catsFrom(titleTokens),
      tagCats: catsFrom(tokens(tags.join(' '))),
      words: words,
      tags: tagSet,
      vendor: String(p.vendor || '').trim().toLowerCase(),
      price: priceOf(p)
    };
  }

  function rank(cur, all) {
    var ci = info(cur);
    var curCats = Object.keys(ci.titleCats);
    var hasCats = curCats.length > 0;
    var out = [];

    all.forEach(function (p) {
      if (!p || p.handle === HANDLE) return;
      var x = info(p);
      var score = 0;
      var shareCat = false;

      curCats.forEach(function (c) {
        if (x.titleCats[c]) { score += 10; shareCat = true; }
        else if (x.tagCats[c]) { score += 2; }
      });

      var typeEqual = !!ci.type && ci.type === x.type;
      if (typeEqual) score += 6;

      var sharedTags = 0;
      Object.keys(ci.tags).forEach(function (t) { if (x.tags[t]) sharedTags++; });
      score += Math.min(sharedTags, 5) * 1.2;

      var overlap = 0;
      Object.keys(ci.words).forEach(function (w) { if (x.words[w]) overlap++; });
      score += Math.min(overlap, 4) * 0.8;

      if (ci.vendor && ci.vendor === x.vendor) score += 1;
      if (ci.price > 0 && x.price > 0) {
        var ratio = Math.min(ci.price, x.price) / Math.max(ci.price, x.price);
        if (ratio > 0.6) score += 1.5;
      }

      /* strict: if we know what the product is (a ring), only show the same kind of product */
      var ok = hasCats ? shareCat : (typeEqual || sharedTags >= 2 || overlap >= 2);
      if (!ok) return;

      var avail = p.available;
      if (avail === undefined) avail = (p.variants || []).some(function (v) { return v.available; });
      out.push({ p: p, score: score, avail: avail ? 1 : 0 });
    });

    out.sort(function (a, b) {
      if (b.avail !== a.avail) return b.avail - a.avail;
      return b.score - a.score;
    });
    return out.slice(0, LIMIT).map(function (o) { return o.p; });
  }

  function fetchCatalog() {
    function page(n) {
      return fetch('/collections/all/products.json?limit=250&page=' + n)
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) { return (j && j.products) ? j.products : []; })
        .catch(function () { return []; });
    }
    return page(1).then(function (first) {
      if (first.length < 250) return first;
      return page(2).then(function (second) { return first.concat(second); });
    });
  }

  function fetchRecommendations(id) {
    return fetch('/recommendations/products.json?product_id=' + id + '&limit=' + LIMIT + '&intent=related')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        var list = (j && j.products) ? j.products : [];
        return list.filter(function (x) { return x && x.handle !== HANDLE; });
      })
      .catch(function () { return []; });
  }

  function fetchSimilar() {
    if (loaded) return loaded;
    loaded = fetch('/products/' + encodeURIComponent(HANDLE) + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cur) {
        if (!cur) return [];
        return fetchCatalog().then(function (all) {
          var ranked = all.length ? rank(cur, all) : [];
          if (ranked.length) return ranked;
          return fetchRecommendations(cur.id);
        });
      })
      .catch(function () { return []; });
    return loaded;
  }

  /* ---------- cart + popup ---------- */
  function addToCart(variantId, btn) {
    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding...';
    var drawer = document.querySelector('cart-drawer');
    var body = { id: variantId, quantity: 1 };
    if (drawer) {
      body.sections = 'cart-drawer,cart-icon-bubble';
      body.sections_url = location.pathname;
    }
    var url = ((window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add') + '.js';
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) throw new Error(data.description || 'error');
        close();
        if (!window.gxOpenCartDrawer(data)) location.href = '/cart';
      })
      .catch(function () {
        btn.textContent = 'Try again';
        setTimeout(function () { btn.textContent = label; }, 1800);
      })
      .then(function () {
        btn.disabled = false;
        if (btn.textContent === 'Adding...') btn.textContent = label;
      });
  }

  function card(p) {
    var c = el('div', 'gx-sim-card');
    var url = p.url || ('/products/' + p.handle);

    var a = el('a', 'gx-sim-media');
    a.href = url;
    var img = p.featured_image;
    if (img && typeof img === 'object') img = img.src || img.url;
    if (!img && p.images && p.images.length) img = (typeof p.images[0] === 'object') ? p.images[0].src : p.images[0];
    if (!img && p.image && p.image.src) img = p.image.src;
    if (img) {
      var im = document.createElement('img');
      im.src = sized(img);
      im.alt = p.title || '';
      im.loading = 'lazy';
      a.appendChild(im);
    }
    c.appendChild(a);

    var variants = p.variants || [];
    var prices = variants.map(function (v) { return cents(v.price); }).filter(function (n) { return n > 0; });
    if (!prices.length) prices = [cents(p.price_min != null ? p.price_min : p.price)];
    var priceMin = Math.min.apply(null, prices);
    var priceMax = Math.max.apply(null, prices);
    var compare = variants.length ? cents(variants[0].compare_at_price) : cents(p.compare_at_price);
    var pr = el('div', 'gx-sim-price');
    var t = money(priceMin);
    if (priceMax > priceMin) t += ' - ' + money(priceMax);
    pr.appendChild(document.createTextNode(t));
    if (priceMax === priceMin && compare > priceMin) pr.appendChild(el('s', '', money(compare)));
    c.appendChild(pr);

    var n = el('a', 'gx-sim-name', p.title);
    n.href = url;
    c.appendChild(n);

    var avail = p.available;
    if (avail === undefined) avail = variants.some(function (v) { return v.available; });
    var b;
    if (!avail) {
      b = el('button', 'gx-sim-add', 'Sold out');
      b.type = 'button';
      b.disabled = true;
    } else if (variants.length === 1) {
      b = el('button', 'gx-sim-add', 'Add to Cart');
      b.type = 'button';
      b.addEventListener('click', function () { addToCart(variants[0].id, b); });
    } else {
      b = el('a', 'gx-sim-add', 'Select Options');
      b.href = url;
    }
    c.appendChild(b);
    return c;
  }

  function close() {
    if (!overlay) return;
    if (overlay.parentNode) overlay.parentNode.removeChild(overlay);
    overlay = null;
    document.body.style.overflow = prevOverflow;
    document.removeEventListener('keydown', onKey);
  }

  function onKey(e) {
    if (e.key === 'Escape') close();
  }

  function open() {
    if (overlay) return;
    overlay = el('div', 'gx-sim-overlay');
    var panel = el('div', 'gx-sim-panel');
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-modal', 'true');
    panel.setAttribute('aria-label', 'Similar products');

    var head = el('div', 'gx-sim-head');
    head.appendChild(el('h3', 'gx-sim-title', 'Similar Products'));
    var x = el('button', 'gx-sim-close', '\u00d7');
    x.type = 'button';
    x.setAttribute('aria-label', 'Close');
    x.addEventListener('click', close);
    head.appendChild(x);
    panel.appendChild(head);

    var body = el('div', 'gx-sim-body');
    body.appendChild(el('div', 'gx-sim-msg', 'Finding similar products...'));
    panel.appendChild(body);
    overlay.appendChild(panel);
    overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });
    document.body.appendChild(overlay);
    prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    document.addEventListener('keydown', onKey);

    fetchSimilar().then(function (list) {
      if (!overlay) return;
      body.innerHTML = '';
      if (!list.length) {
        body.appendChild(el('div', 'gx-sim-msg', 'No similar products found right now.'));
        return;
      }
      var grid = el('div', 'gx-sim-grid');
      list.forEach(function (p) { grid.appendChild(card(p)); });
      body.appendChild(grid);
    });
  }

  function addButton() {
    var viewer = document.querySelector('media-gallery [id^="GalleryViewer"]');
    if (!viewer || viewer.querySelector('.gx-sim-btn')) return;
    if (!document.getElementById('gx-sim-css')) {
      var st = document.createElement('style');
      st.id = 'gx-sim-css';
      st.textContent = CSS;
      document.head.appendChild(st);
    }
    viewer.classList.add('gx-sim-host');
    var b = el('button', 'gx-sim-btn');
    b.type = 'button';
    b.innerHTML = ICON + '<span>See Similar</span>';
    b.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      open();
    });
    /* start downloading only when the customer is about to use it (hover / touch), never on page load */
    b.addEventListener('mouseenter', function () { fetchSimilar(); }, { once: true });
    b.addEventListener('touchstart', function () { fetchSimilar(); }, { once: true, passive: true });
    viewer.appendChild(b);
  }

  document.addEventListener('DOMContentLoaded', addButton);
  document.addEventListener('shopify:section:load', addButton);
  window.addEventListener('load', addButton);
  addButton();
  setTimeout(addButton, 600);
})();

/* GEHNA: make the single "Product description" tab collapsible (closed by default) */
(function () {
  var CSS = ''
    + '.gx-tab-chev{display:inline-block;vertical-align:middle;margin-left:0.8rem;transition:transform 0.2s ease}'
    + '.gx-tab-open .gx-tab-chev{transform:rotate(180deg)}'
    + '.gx-tab-closed .tab-content-wrapper{display:none}'
    + '.product_accordian_tab.gx-tab-closed .product_tab_three{padding-bottom:0}'
    + '.product_accordian_tab [role=button]{cursor:pointer}';
  var CHEV = '<svg class="gx-tab-chev" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>';

  function init() {
    document.querySelectorAll('.product_accordian_tab').forEach(function (root) {
      if (root.dataset.gxTab) return;
      var panels = root.querySelectorAll('.tabs-content > li');
      if (panels.length !== 1) return;
      root.dataset.gxTab = '1';

      if (!document.getElementById('gx-tab-css')) {
        var st = document.createElement('style');
        st.id = 'gx-tab-css';
        st.textContent = CSS;
        document.head.appendChild(st);
      }

      root.classList.add('gx-tab-closed');
      var links = root.querySelectorAll('.product_tab_wrapper--tab-title .tabs li a, .tab-content-title a');
      links.forEach(function (a) {
        a.insertAdjacentHTML('beforeend', CHEV);
        a.setAttribute('role', 'button');
        a.setAttribute('aria-expanded', 'false');
        a.addEventListener('click', function () {
          var closed = root.classList.toggle('gx-tab-closed');
          root.classList.toggle('gx-tab-open', !closed);
          links.forEach(function (l) { l.setAttribute('aria-expanded', closed ? 'false' : 'true'); });
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  init();
})();

/* GEHNA: "Estimated Delivery Time" (pan-India pincode check) on product pages.
   It is an ESTIMATE. The numbers below are only defaults: they are overridden by the theme editor section
   "Delivery estimate" (sections/gehna-delivery.liquid) when that section is present. */
(function () {
  /* ---- defaults (used only if the theme editor section is missing) ---- */
  var TITLE = 'Estimated Delivery Time';
  var CUTOFF_HOUR = 16;
  var DISPATCH_DAYS = [1, 2, 3, 4, 5, 6];
  var SKIP_SUNDAY = true;
  var TRANSIT = { '1': [4, 6], '2': [4, 6], '3': [4, 6], '4': [3, 5], '5': [2, 4], '6': [3, 5], '7': [5, 7], '8': [4, 6], '9': [5, 8] };
  var REMOTE_PREFIXES = ['18', '19', '78', '79', '744'];
  var REMOTE_EXTRA = [2, 3];
  /* -------------------------------------------------------------------- */

  var STORE_KEY = 'gx_delivery_pin';
  var DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var PIN_SVG = '<svg class="gx-del__pin" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 21s-7-6.2-7-11a7 7 0 0 1 14 0c0 4.8-7 11-7 11z"/><circle cx="12" cy="10" r="2.5"/></svg>';
  var CSS = ''
    + '.gx-del{clear:both;width:100%;box-sizing:border-box;margin:1.6rem 0;text-align:left}'
    + '.gx-del__title{margin:0 0 0.8rem;font-size:1.6rem;font-weight:500;letter-spacing:0.02em;color:#241F1C}'
    + '.gx-del__box{background:#fff;border:1px solid #E6DFD6;border-radius:1.6rem;padding:1.2rem 1.4rem;box-shadow:0 4px 16px rgba(36,31,28,0.05)}'
    + '.gx-del__row{display:flex;align-items:center;gap:0.8rem;font-size:1.4rem;color:#241F1C}'
    + '.gx-del__pin{flex:none;color:#7A3E4D}'
    + '.gx-del__loc{flex:1 1 auto;min-width:0}'
    + '.gx-del__change{flex:none;padding:0;background:none;border:0;font:inherit;font-size:1.3rem;font-weight:600;color:#7A3E4D;text-decoration:underline;text-underline-offset:0.3rem;cursor:pointer}'
    + '.gx-del__est{margin-top:1rem;padding:1rem 1.2rem;background:#FAF8F5;border-radius:1rem;font-size:1.35rem;line-height:1.5;color:#241F1C}'
    + '.gx-del__date{color:#7A3E4D}'
    + '.gx-del__form{display:flex;gap:0.8rem}'
    + '.gx-del__input{flex:1 1 auto;min-width:0;height:4.4rem;box-sizing:border-box;padding:0 1.2rem;background:#fff;border:1px solid #D9D0C5;border-radius:0.8rem;font:inherit;font-size:1.6rem;color:#241F1C}'
    + '.gx-del__go{flex:none;height:4.4rem;padding:0 2rem;background:#241F1C;border:0;border-radius:0.8rem;color:#fff;font:inherit;font-size:1.4rem;font-weight:600;cursor:pointer}'
    + '.gx-del__go[disabled]{opacity:0.6;cursor:wait}'
    + '.gx-del__msg{margin-top:0.8rem;font-size:1.2rem;color:#A12C2C}'
    + '.gx-del__msg:empty{display:none}';

  function readConfig() {
    try {
      var n = document.getElementById('gx-delivery-config');
      if (n) return JSON.parse(n.textContent);
    } catch (e) {}
    return null;
  }

  /* returns false when the merchant switched the widget off in the theme editor */
  function applyConfig(C) {
    if (!C) return true;
    if (C.enabled === false) return false;
    if (C.title) TITLE = String(C.title);
    if (typeof C.cutoff === 'number') CUTOFF_HOUR = C.cutoff;
    if (C.days) {
      var d = [];
      for (var i = 0; i < 7; i++) { if (C.days[i]) d.push(i); }
      if (d.length) DISPATCH_DAYS = d;
    }
    if (typeof C.skipSunday === 'boolean') SKIP_SUNDAY = C.skipSunday;
    if (C.zones) {
      for (var k in C.zones) {
        if (!Object.prototype.hasOwnProperty.call(C.zones, k)) continue;
        var lo = Number(C.zones[k][0]);
        var hi = Number(C.zones[k][1]);
        if (hi < lo) hi = lo;
        if (lo > 0) TRANSIT[k] = [lo, hi];
      }
    }
    if (typeof C.remotePrefixes === 'string') {
      REMOTE_PREFIXES = C.remotePrefixes.split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    }
    if (C.remoteExtra) REMOTE_EXTRA = [Number(C.remoteExtra[0]) || 0, Number(C.remoteExtra[1]) || 0];
    return true;
  }

  function el(tag, cls) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    return e;
  }

  function digitsOnly(s) {
    return s.split('').filter(function (c) { return c >= '0' && c <= '9'; }).join('');
  }

  /* any 6-digit number that does not start with 0 is accepted, so every real Indian pincode works */
  function validPin(p) {
    return p.length === 6 && p.charAt(0) !== '0';
  }

  function plural(n, word) {
    return n + ' ' + word + (n === 1 ? '' : 's');
  }

  function fmt(d) {
    return DAYS[d.getUTCDay()] + ', ' + d.getUTCDate() + ' ' + MONTHS[d.getUTCMonth()];
  }

  function addDays(d, n) {
    return new Date(d.getTime() + n * 86400000);
  }

  /* add delivery days (Sundays skipped when SKIP_SUNDAY is on) */
  function addWorking(d, n) {
    var x = new Date(d.getTime());
    while (n > 0) {
      x = addDays(x, 1);
      if (!(SKIP_SUNDAY && x.getUTCDay() === 0)) n--;
    }
    return x;
  }

  function transitFor(pin) {
    var base = TRANSIT[pin.charAt(0)] || [4, 7];
    var t = [base[0], base[1]];
    for (var i = 0; i < REMOTE_PREFIXES.length; i++) {
      if (pin.indexOf(REMOTE_PREFIXES[i]) === 0) {
        t = [t[0] + REMOTE_EXTRA[0], t[1] + REMOTE_EXTRA[1]];
        break;
      }
    }
    return t;
  }

  function estimateHtml(pin) {
    /* current time in IST, read with the getUTC* methods */
    var now = new Date(Date.now() + 330 * 60000);
    var beforeCutoff = DISPATCH_DAYS.indexOf(now.getUTCDay()) > -1 && now.getUTCHours() < CUTOFF_HOUR;
    var dispatch = new Date(now.getTime());
    if (!beforeCutoff) {
      do { dispatch = addDays(dispatch, 1); } while (DISPATCH_DAYS.indexOf(dispatch.getUTCDay()) < 0);
    }
    var t = transitFor(pin);
    var dMin = addWorking(dispatch, t[0]);
    var dMax = addWorking(dispatch, t[1]);

    var html = (fmt(dMin) === fmt(dMax))
      ? 'Delivery by <strong class="gx-del__date">' + fmt(dMax) + '</strong>.'
      : 'Delivery between <strong class="gx-del__date">' + fmt(dMin) + '</strong> and <strong class="gx-del__date">' + fmt(dMax) + '</strong>.';

    if (beforeCutoff) {
      var cut = Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), CUTOFF_HOUR, 0, 0);
      var rem = Math.max(0, cut - now.getTime());
      var hrs = Math.floor(rem / 3600000);
      var mins = Math.floor((rem % 3600000) / 60000);
      var left = hrs > 0 ? plural(hrs, 'hour') + ' ' + plural(mins, 'minute') : plural(mins, 'minute');
      html += ' Order within <strong>' + left + '</strong> to dispatch today.';
    } else {
      html += ' Orders placed now are dispatched on <strong>' + fmt(dispatch) + '</strong>.';
    }
    return html;
  }

  /* optional city/state lookup. It only decorates the result: if the service is slow, down,
     or does not know the pincode, we still show the delivery estimate (just without the city name). */
  function lookup(pin) {
    var ctrl = window.AbortController ? new AbortController() : null;
    var timer = setTimeout(function () { if (ctrl) ctrl.abort(); }, 4000);
    return fetch('https://api.postalpincode.in/pincode/' + pin, ctrl ? { signal: ctrl.signal } : undefined)
      .then(function (r) { return r.json(); })
      .then(function (j) {
        clearTimeout(timer);
        var d = j && j[0];
        if (d && d.Status === 'Success' && d.PostOffice && d.PostOffice.length) {
          return { ok: true, place: d.PostOffice[0].District + ', ' + d.PostOffice[0].State };
        }
        return { ok: true, place: '' };
      })
      .catch(function () {
        clearTimeout(timer);
        return { ok: true, place: '' };
      });
  }

  function save(pin, place) {
    try { localStorage.setItem(STORE_KEY, JSON.stringify({ pin: pin, place: place || '' })); } catch (e) {}
  }

  function load() {
    try {
      var v = JSON.parse(localStorage.getItem(STORE_KEY) || 'null');
      if (v && validPin(String(v.pin))) return v;
    } catch (e) {}
    return null;
  }

  function init() {
    if (document.querySelector('.gx-del')) return;
    var root = document.querySelector('.product__info-container');
    if (!root) return;
    if (!applyConfig(readConfig())) return;

    var st = document.createElement('style');
    st.textContent = CSS;
    document.head.appendChild(st);

    var card = el('div', 'gx-del');
    var title = el('h3', 'gx-del__title');
    title.textContent = TITLE;
    card.appendChild(title);
    var box = el('div', 'gx-del__box');
    card.appendChild(box);
    var timer = null;

    function showForm(prefill, err) {
      clearInterval(timer);
      box.innerHTML = '';
      var form = el('div', 'gx-del__form');
      var inp = el('input', 'gx-del__input');
      inp.type = 'text';
      inp.inputMode = 'numeric';
      inp.maxLength = 6;
      inp.placeholder = 'Enter delivery pincode';
      inp.setAttribute('aria-label', 'Delivery pincode');
      inp.value = prefill || '';
      var go = el('button', 'gx-del__go');
      go.type = 'button';
      go.textContent = 'Check';
      form.appendChild(inp);
      form.appendChild(go);
      var msg = el('div', 'gx-del__msg');
      if (err) msg.textContent = err;
      box.appendChild(form);
      box.appendChild(msg);

      function submit() {
        var v = digitsOnly(inp.value);
        if (!validPin(v)) {
          msg.textContent = 'Please enter a valid 6-digit pincode.';
          return;
        }
        msg.textContent = '';
        go.disabled = true;
        go.textContent = 'Checking...';
        lookup(v).then(function (r) {
          save(v, r.place);
          showResult(v, r.place);
        });
      }
      go.addEventListener('click', submit);
      inp.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); submit(); }
      });
    }

    function showResult(pin, place) {
      clearInterval(timer);
      box.innerHTML = '';
      var row = el('div', 'gx-del__row');
      row.insertAdjacentHTML('beforeend', PIN_SVG);
      var loc = el('span', 'gx-del__loc');
      loc.appendChild(document.createTextNode('Deliver to '));
      var b = document.createElement('strong');
      b.textContent = pin;
      loc.appendChild(b);
      if (place) loc.appendChild(document.createTextNode(' (' + place + ')'));
      row.appendChild(loc);
      var ch = el('button', 'gx-del__change');
      ch.type = 'button';
      ch.textContent = 'Change';
      ch.addEventListener('click', function () { showForm(pin); });
      row.appendChild(ch);
      var est = el('div', 'gx-del__est');
      box.appendChild(row);
      box.appendChild(est);
      function paint() { est.innerHTML = estimateHtml(pin); }
      paint();
      timer = setInterval(paint, 60000);
    }

    var saved = load();
    if (saved) showResult(String(saved.pin), saved.place);
    else showForm();

    var anchor = root.querySelector('.payment-icon-block');
    if (anchor && anchor.parentNode) {
      anchor.parentNode.insertBefore(card, anchor);
    } else {
      var pf = root.querySelector('.product-form-block');
      if (pf && pf.parentNode) pf.parentNode.insertBefore(card, pf.nextSibling);
      else root.appendChild(card);
    }
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  init();
})();

/* GEHNA: "Add to Cart" button under the price of every card in the Related products slider.
   SPEED: the product info for these buttons is fetched only when the Related products area is about to scroll into view.
   The button shows up instantly (disabled) and becomes active as soon as the product info arrives. */
(function () {
  var CSS = ''
    + '.related-product-list .card-information .gx-card-atc,.gx-card-atc{display:flex!important;align-items:center;justify-content:center;width:100%;box-sizing:border-box;min-height:4rem;margin:0.8rem 0 0!important;padding:0 1rem!important;border:0;border-radius:0.8rem;background:#241F1C!important;color:#fff!important;font:inherit;font-size:1.3rem!important;font-weight:600!important;line-height:1.2!important;letter-spacing:0.02em!important;text-transform:none!important;text-decoration:none!important;text-align:center!important;cursor:pointer}'
    + '.related-product-list .card-information .gx-card-atc[disabled],.gx-card-atc[disabled]{opacity:0.6;cursor:wait}'
    /* hide hidden-but-space-taking leftovers of the theme card so there is no big gap above the button */
    + '.related-product-list .product-card-desc,.related-product-list .card__information-volume-pricing-note{display:none!important}'
    + '.related-product-list .product_tile_color_holder:empty{display:none!important}';
  var cache = {};
  var mo = null;

  function getProduct(handle) {
    if (!cache[handle]) {
      cache[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return cache[handle];
  }

  function handleFrom(a) {
    var href = a.getAttribute('href') || '';
    var part = href.split('/products/')[1];
    if (!part) return '';
    part = part.split('?')[0].split('#')[0].split('/')[0];
    try { return decodeURIComponent(part); } catch (e) { return part; }
  }

  function addToCart(variantId, btn) {
    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding...';
    var drawer = document.querySelector('cart-drawer');
    var body = { id: variantId, quantity: 1 };
    if (drawer) {
      body.sections = 'cart-drawer,cart-icon-bubble';
      body.sections_url = location.pathname;
    }
    var url = ((window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add') + '.js';
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) throw new Error(data.description || 'error');
        if (!window.gxOpenCartDrawer(data)) location.href = '/cart';
      })
      .catch(function () {
        btn.textContent = 'Try again';
        setTimeout(function () { btn.textContent = label; }, 1800);
      })
      .then(function () {
        btn.disabled = false;
        if (btn.textContent === 'Adding...') btn.textContent = label;
      });
  }

  function swapToLink(btn, href, text) {
    var a = document.createElement('a');
    a.className = 'gx-card-atc';
    a.textContent = text;
    a.href = href;
    if (btn.parentNode) btn.parentNode.replaceChild(a, btn);
  }

  function decorate(li) {
    if (li.dataset.gxAtc) return;
    var a = li.querySelector('a[href*="/products/"]');
    if (!a) return;
    var handle = handleFrom(a);
    if (!handle) return;
    li.dataset.gxAtc = '1';

    /* show the button right away (disabled) so the layout does not jump */
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'gx-card-atc';
    b.textContent = 'Add to Cart';
    b.disabled = true;
    var price = li.querySelector('.card-information .price');
    if (price && price.parentNode) price.parentNode.insertBefore(b, price.nextSibling);
    else li.appendChild(b);

    getProduct(handle).then(function (p) {
      if (!p) {
        swapToLink(b, '/products/' + handle, 'View product');
        return;
      }
      if (!p.available) {
        b.textContent = 'Sold out';
      } else if (p.variants && p.variants.length === 1) {
        b.disabled = false;
        b.addEventListener('click', function () { addToCart(p.variants[0].id, b); });
      } else {
        swapToLink(b, p.url || ('/products/' + handle), 'Select Options');
      }
    });
  }

  function watchList(list) {
    if (list.dataset.gxAtcWatch) return;
    list.dataset.gxAtcWatch = '1';
    function run() {
      if (!document.getElementById('gx-card-atc-css')) {
        var st = document.createElement('style');
        st.id = 'gx-card-atc-css';
        st.textContent = CSS;
        document.head.appendChild(st);
      }
      Array.prototype.forEach.call(list.children, function (li) {
        if (li.tagName === 'LI') decorate(li);
      });
    }
    if (!('IntersectionObserver' in window)) { run(); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { io.disconnect(); run(); }
      });
    }, { rootMargin: '400px 0px' });
    io.observe(list);
  }

  function enhance() {
    var lists = document.querySelectorAll('.related-product-list');
    if (!lists.length) return;
    Array.prototype.forEach.call(lists, watchList);
    /* the list exists now, so stop watching the whole page */
    if (mo) { mo.disconnect(); mo = null; }
  }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; enhance(); });
  }
  document.addEventListener('DOMContentLoaded', enhance);
  document.addEventListener('shopify:section:load', enhance);
  enhance();
  /* the related products are loaded after the page, so watch for them until they show up */
  if (window.MutationObserver && !document.querySelector('.related-product-list')) {
    mo = new MutationObserver(schedule);
    mo.observe(document.body || document.documentElement, { childList: true, subtree: true });
    setTimeout(function () { if (mo) { mo.disconnect(); mo = null; } }, 15000);
  }
})();

/* GEHNA: "Recently Viewed" row on product pages (uses localStorage + /products/<handle>.js).
   SPEED: the product info is downloaded only after the page has finished loading and the browser is idle. */
(function () {
  var parts = location.pathname.split('/products/');
  if (parts.length < 2) return;
  var here = decodeURIComponent(parts[1].split('/')[0]);
  if (!here) return;

  var KEY = 'gx_recent_products';
  var MAX = 12;
  var SHOW = 8;
  var list = [];
  try {
    list = JSON.parse(localStorage.getItem(KEY) || '[]');
    if (!Array.isArray(list)) list = [];
  } catch (e) { list = []; }

  var others = list.filter(function (h) { return h !== here; }).slice(0, SHOW);
  try {
    localStorage.setItem(KEY, JSON.stringify([here].concat(list.filter(function (h) { return h !== here; })).slice(0, MAX)));
  } catch (e) {}
  if (!others.length) return;

  var CSS = ''
    + '.gx-rv{clear:both;width:100%;box-sizing:border-box;max-width:var(--page-width,140rem);margin:0 auto;padding:3.2rem 1.6rem 4rem;text-align:left}'
    + '@media screen and (min-width:750px){.gx-rv{padding:4rem 3.2rem 5rem}}'
    + '.gx-rv__title{margin:0 0 1.6rem;font-size:2.4rem;line-height:1.2;text-align:left}'
    + '.gx-rv__row{display:flex;gap:1.2rem;overflow-x:auto;scroll-snap-type:x mandatory;padding-bottom:0.8rem;-webkit-overflow-scrolling:touch}'
    + '.gx-rv__card{flex:0 0 calc((100% - 1.2rem) / 2);min-width:0;scroll-snap-align:start}'
    + '@media screen and (min-width:750px){.gx-rv__card{flex-basis:calc((100% - 3.6rem) / 4)}}'
    + '.gx-rv__media{display:block;aspect-ratio:1/1;overflow:hidden;border-radius:0.8rem;background:#F3EFE9}'
    + '.gx-rv__media img{display:block;width:100%;height:100%;object-fit:cover}'
    + '.gx-rv__price{margin:1rem 0 0.2rem;font-size:1.5rem;font-weight:600;color:#241F1C}'
    + '.gx-rv__price s{margin-left:0.6rem;font-weight:400;color:#625B56}'
    + '.gx-rv__name{display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;min-height:2.8em;margin:0 0 1rem;font-size:1.4rem;line-height:1.4;color:#241F1C;text-decoration:none}'
    + '.gx-rv__btn{display:flex;align-items:center;justify-content:center;width:100%;box-sizing:border-box;min-height:4.4rem;padding:0 1rem;border:0;border-radius:0.8rem;background:#241F1C;color:#fff;font:inherit;font-size:1.4rem;font-weight:600;text-decoration:none;cursor:pointer}'
    + '.gx-rv__btn[disabled]{opacity:0.6;cursor:not-allowed}';

  function money(c) {
    var code = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'INR';
    if (code === 'INR') return 'Rs. ' + (c / 100).toFixed(2);
    try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: code }).format(c / 100); }
    catch (e) { return (c / 100).toFixed(2); }
  }

  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }

  function sized(url) {
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=480';
  }

  function addToCart(variantId, btn) {
    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding...';
    var drawer = document.querySelector('cart-drawer');
    var body = { id: variantId, quantity: 1 };
    if (drawer) {
      body.sections = 'cart-drawer,cart-icon-bubble';
      body.sections_url = location.pathname;
    }
    var url = ((window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add') + '.js';
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) throw new Error(data.description || 'error');
        if (!window.gxOpenCartDrawer(data)) location.href = '/cart';
      })
      .catch(function () {
        btn.textContent = 'Try again';
        setTimeout(function () { btn.textContent = label; }, 1800);
      })
      .then(function () {
        btn.disabled = false;
        if (btn.textContent === 'Adding...') btn.textContent = label;
      });
  }

  function card(item) {
    var c = el('div', 'gx-rv__card');

    var a = el('a', 'gx-rv__media');
    a.href = item.url;
    if (item.featured_image) {
      var im = document.createElement('img');
      im.src = sized(item.featured_image);
      im.alt = item.title;
      im.loading = 'lazy';
      a.appendChild(im);
    }
    c.appendChild(a);

    var p = el('div', 'gx-rv__price');
    var t = money(item.price_min);
    if (item.price_max !== item.price_min) t += ' - ' + money(item.price_max);
    p.appendChild(document.createTextNode(t));
    if (item.price_max === item.price_min && item.compare_at_price > item.price) {
      p.appendChild(el('s', '', money(item.compare_at_price)));
    }
    c.appendChild(p);

    var n = el('a', 'gx-rv__name', item.title);
    n.href = item.url;
    c.appendChild(n);

    var b;
    if (!item.available) {
      b = el('button', 'gx-rv__btn', 'Sold out');
      b.type = 'button';
      b.disabled = true;
    } else if (item.variants && item.variants.length === 1) {
      b = el('button', 'gx-rv__btn', 'Add to Cart');
      b.type = 'button';
      b.addEventListener('click', function () { addToCart(item.variants[0].id, b); });
    } else {
      b = el('a', 'gx-rv__btn', 'Select Options');
      b.href = item.url;
    }
    c.appendChild(b);
    return c;
  }

  function render(items) {
    var main = document.getElementById('MainContent');
    if (!main || document.querySelector('.gx-rv')) return;

    var st = document.createElement('style');
    st.textContent = CSS;
    document.head.appendChild(st);

    var sec = el('section', 'gx-rv');
    sec.appendChild(el('h2', 'gx-rv__title', 'Recently Viewed'));
    var row = el('div', 'gx-rv__row');
    items.forEach(function (it) { row.appendChild(card(it)); });
    sec.appendChild(row);

    var target = null;
    main.querySelectorAll('.shopify-section').forEach(function (s) {
      if (!target && /related-products/.test(s.id)) target = s;
    });
    if (target) target.parentNode.insertBefore(sec, target);
    else main.appendChild(sec);
  }

  function start() {
    Promise.all(others.map(function (h) {
      return fetch('/products/' + encodeURIComponent(h) + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (items) {
      items = items.filter(Boolean);
      if (items.length) render(items);
    });
  }

  /* wait until the page is fully loaded and the browser has nothing better to do */
  function whenIdle() {
    if (window.requestIdleCallback) window.requestIdleCallback(start, { timeout: 4000 });
    else setTimeout(start, 2500);
  }
  if (document.readyState === 'complete') whenIdle();
  else window.addEventListener('load', whenIdle);
})();
